module.exports = __webpack_public_path__ + "static/img/service_notice.13869ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yearContent/service_notice.jpg
// module id = u2Tx
// module chunks = 2